import Map from "./Map";
import Main from "./Main";
import ProviderList from "./ProviderList";
import {getRealQueueName} from "../utils/queueHelper";

const Application = (props) => {
    const query = new URLSearchParams(props.location.search);
    const data = query.get('data');
    const userParams = props.match.params;
    let startQueueName=props.startQueueName;
    if(userParams.queueName !== undefined && userParams.queueName){
        startQueueName= userParams.queueName
    }

    if (!startQueueName && userParams?.department) {
        startQueueName = getRealQueueName(userParams.department);
    }

    const element = query.get('element');
        switch (element){
            case "map":
                return <Map/>
            case "providers":
                return <ProviderList/>
            default :
                return <Main language="es" data={data} userParams={userParams} startQueueName={startQueueName} />
        }
}
export default Application